import React from "react";
import { CustomInput } from "@lwt-helix/controls";
import { periodKeys, terms } from '../../constants';
import { Dropdown } from "@lwt-helix/dropdown";
import { getBeginOrEndOptions } from "../../helpers/beginEndMonth";
import {
    getQuarterFormatted,
    longQuarterNumberAndYear,
    monthAndYearFormat
} from "../../../agent-production/helpers/dataFormatters";
import { useSearchStore } from "../../../store/search/store";
import { modules } from "../../../constants";
import PropTypes from 'prop-types';

const PeriodComparison = ({ setSelectedPeriodComparison, selectedPeriodComparison,
    agentData, intervalType, onBeginChange, onEndChange }) => {

    const { 
        storedChartFilters, 
    } = useSearchStore(state => ({
        storedChartFilters: state[modules.marketDynamics.marketDynamics]?.chartFilters,
    }));

    const formatter = intervalType === terms.quarter ? getQuarterFormatted : monthAndYearFormat;
    const defaultBeginValue = agentData ? agentData[agentData?.length - 1]?.timePeriodStart : '';
    const defaultEndValue = agentData ? agentData[0]?.timePeriodEnd : '';

    const selectedBeginValue = storedChartFilters?.selectedBeginValue ?? defaultBeginValue;
    const selectedEndValue = storedChartFilters?.selectedEndValue ?? defaultEndValue;

    const beginOptions = selectedEndValue ? getBeginOrEndOptions(terms.begin, agentData, formatter, onBeginChange, selectedEndValue) : [];
    const endOptions = selectedBeginValue ? getBeginOrEndOptions(terms.end, agentData, formatter, onEndChange, selectedBeginValue) : [];
    return selectedBeginValue ? <div className='period-comparison'>
        <CustomInput
            className='d-inline-block mr-4'
            key={1}
            dataLwtId={'begin-end'}
            id={'begin-end'}
            value={periodKeys.beginVsEndMonth}
            type="radio"
            name="period-comparison"
            label={terms.beginVsEndMonthLabel}
            checked={selectedPeriodComparison === periodKeys.beginVsEndMonth}
            onChange={(event) => setSelectedPeriodComparison(event.target.value)}
        />
        <CustomInput
            className='d-inline-block mr-5'
            key={2}
            dataLwtId={'whole-time-period'}
            id={'whole-time-period'}
            value={periodKeys.wholeTimePeriod}
            type="radio"
            name="period-comparison"
            label={terms.wholeTimePeriodLabel}
            checked={selectedPeriodComparison === periodKeys.wholeTimePeriod}
            onChange={(event) => setSelectedPeriodComparison(event.target.value)}
        />

        <Dropdown
            className='d-inline-block mr-3'
            dataLwtId='periodComparisonBeginOptions'
            toggleProps={{
                dataLwtId: 'no-split-toggle',
                id: 'caret',
                caret: true,
                children: terms.beginPeriod(formatter(selectedBeginValue, longQuarterNumberAndYear))
            }}
            items={beginOptions}
            menuProps={{
                dataLwtId: 'share-menu',
                right: true,
                className: 'periodComparisonDropdown'
            }}
            size='sm'
        />

        <Dropdown
            className='d-inline-block'
            dataLwtId='periodComparisonEndOptions'
            toggleProps={{
                dataLwtId: 'no-split-toggle',
                id: 'caret',
                caret: true,
                children: terms.endPeriod(formatter(selectedEndValue, longQuarterNumberAndYear))
            }}
            items={endOptions}
            menuProps={{
                dataLwtId: 'share-menu',
                right: true,
                className: 'periodComparisonDropdown'
            }}
            size='sm'
        />
    </div> : null;
};

PeriodComparison.propTypes = {
    setSelectedPeriodComparison: PropTypes.func,
    selectedPeriodComparison: PropTypes.string,
    agentData: PropTypes.array,
    intervalType: PropTypes.string,
    onBeginChange: PropTypes.func,
    onEndChange: PropTypes.func,
};

export default PeriodComparison;
